import { Alert, Typography } from "antd";
import CustomButton from "../CustomButton/Button";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BTN_TXT, GLOBAL_CONSTANTS, USERTYPE_ID } from "../../constants/constants";
import "./Banner.scss";

const { Text } = Typography;

const Banner = () => {
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();

    const kycPendingBanner = (
        <div className="banner-content">
            <Text strong style={{ fontSize: 14, color: "#332E1C" }}>
                {GLOBAL_CONSTANTS.COMPLETE_KYC_TXT}
            </Text>
            <CustomButton
                type="primary"
                onClick={() => {
                    navigate("/kyc");
                }}
                style={{ backgroundColor: "#533F02", borderRadius: 8 }}
            >
                {BTN_TXT.COMPLETE_NOW}
            </CustomButton>
        </div>
    );

    const kycUnderReviewBanner = (
        <div className="banner-content">
            <Text strong style={{ fontSize: 14, color: "#332E1C" }}>
                {GLOBAL_CONSTANTS.KYC_UNDER_REVIEW_TXT}
            </Text>
        </div>
    );

    const slaBanner = (
        <div className="banner-content">
            <Text strong style={{ fontSize: 14, color: "#332E1C" }}>
                {GLOBAL_CONSTANTS.SLA_NOT_SIGNED_TXT}
            </Text>
            <CustomButton
                type="primary"
                style={{ backgroundColor: "#533F02", borderRadius: 8 }}
                onClick={() => {
                    navigate("/sla");
                }}
            >
                {BTN_TXT.SIGN_SLA}
            </CustomButton>
        </div>
    );

    const boardResBanner = (
        <div className="banner-content">
            {user?.boardResolution?.docUrl && user?.boardResolution?.rejected ? (
                <Text strong style={{ color: "#332E1C" }}>
                    {GLOBAL_CONSTANTS.BOARD_RES_REJECTED_TXT}
                </Text>
            ) : user?.boardResolution?.docUrl && !user?.boardResolution?.rejected ? (
                <Text strong style={{ color: "#332E1C" }}>
                    {GLOBAL_CONSTANTS.BOARD_RES_UNDER_REVIEW_TXT}
                </Text>
            ) : (
                <Text strong style={{ color: "#332E1C" }}>
                    {GLOBAL_CONSTANTS.BOARD_RES_PENDING_TXT}
                </Text>
            )}
            {user?.boardResolution?.docUrl &&
                !user?.boardResolution?.rejected ? null : (
                <CustomButton
                    type="primary"
                    style={{ backgroundColor: "#533F02", borderRadius: 8 }}
                    onClick={() => {
                        navigate("/board-resolution");
                    }}
                >
                    {user?.boardResolution?.docUrl && user?.boardResolution?.rejected
                        ? BTN_TXT.REUPLOAD
                        : BTN_TXT.UPLOAD_NOW}
                </CustomButton>
            )}
        </div>
    );

    const s1Status = user?.step1Status || user?.businessProfile?.step1Status;
    const s2Status = user?.step2Status || user?.businessProfile?.step2Status;
    const s3Status = user?.step3Status || user?.businessProfile?.step3Status;
    const s1Remarks = user?.step1Remarks || user?.businessProfile?.step1Remarks;
    const s2Remarks = user?.step2Remarks || user?.businessProfile?.step2Remarks;
    const s3Remarks = user?.step3Remarks || user?.businessProfile?.step3Remarks;

    const userTypeId = user?.userTypeId || user?.businessProfile?.userTypeId;
    const isHuf = userTypeId === USERTYPE_ID.HUF;
    const isEntityOrNbfc =
        userTypeId === USERTYPE_ID.ENTITY ||
        userTypeId === USERTYPE_ID.NBFC;

    let rejectedStepMsg = "";
    if (s1Status === 'REJECTED') {
        rejectedStepMsg = `Step 1 (Identity) rejected: ${s1Remarks || "Invalid documents"}`;
    } else if (s2Status === 'REJECTED') {
        const step2Label = isHuf ? "HUF PAN" : isEntityOrNbfc ? "Business Details" : "Bank Account";
        rejectedStepMsg = `Step 2 (${step2Label}) rejected: ${s2Remarks || "Invalid details"}`;
    } else if (s3Status === 'REJECTED') {
        rejectedStepMsg = `Step 3 (Bank Account) rejected: ${s3Remarks || "Invalid bank details"}`;
    }

    const kycRejectedBanner = (
        <div className="banner-content">
            <Text strong style={{ fontSize: 14, color: "#820014" }}>
                {rejectedStepMsg}
            </Text>
            <CustomButton
                type="primary"
                onClick={() => {
                    navigate("/kyc");
                }}
                style={{ backgroundColor: "#ff4d4f", borderRadius: 8, borderColor: "#ff4d4f" }}
            >
                Re-submit Now
            </CustomButton>
        </div>
    );

    const renderBanner = () => {
        const status = user?.orgStatusId || user?.businessProfile?.orgStatusId || user?.userStatusId;

        if (rejectedStepMsg) {
            return kycRejectedBanner;
        }

        if (
            status === GLOBAL_CONSTANTS.STAT_PEN_ID ||
            status === GLOBAL_CONSTANTS.STAT_KYC_PEN_ID
        ) {
            return kycPendingBanner;
        }

        if (status === GLOBAL_CONSTANTS.STAT_KYC_REVIEW_ID) {
            return kycUnderReviewBanner;
        }

        if (!user?.isSlaSigned) {
            return slaBanner;
        }

        if (
            (user?.userTypeId === "UTY1000006" || user?.userTypeId === "UTY1000008") &&
            (!user?.boardResolution?.docUrl ||
                user?.boardResolution?.rejected ||
                (user?.boardResolution?.docUrl &&
                    !user?.boardResolution?.rejected &&
                    !user?.boardResolution?.isVerified))
        ) {
            return boardResBanner;
        }

        return null;
    };

    const bannerContent = renderBanner();

    return (
        <>
            {bannerContent && (
                <Alert
                    banner
                    showIcon={false}
                    className="custom-banner"
                    message={bannerContent}
                />
            )}
        </>
    );
};

export default Banner;
